import { Subject } from 'rxjs';

import { Injectable, Type } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SideBarService {
  private sideBarComponentLoad = new Subject<{ type: Type<unknown>; data: unknown; }>();

  sideBarComponentLoad$ = this.sideBarComponentLoad.asObservable();

  loadComponent(type: Type<unknown>, data: unknown) {
    this.sideBarComponentLoad.next({ type , data });
  }
}
